'use strict';

import $ from 'jquery';

$(document).ready(function(){
	// cta layout for even number blocks
	$('.field--name-field-list-of-internal-links').each(function(){
		let numItems = $(this).find('> .field__item').length;
		if (numItems % 2 == 0){
			$(this).addClass('even');
		}
	})
})
